export default __webpack_public_path__ + "static/2024-b62355bfe3d36bee7ae47ae40e401ece.png";